export default "__VITE_ASSET__175c6402__"